const getters = {
  message: (state) => state.message
};

export default {
  getters
};
